import { render } from "./AjustesTopside.vue?vue&type=template&id=560a5e7a&scoped=true"
import script from "./AjustesTopside.vue?vue&type=script&lang=js"
export * from "./AjustesTopside.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "./AjustesTopside.vue?vue&type=style&index=1&id=560a5e7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-560a5e7a"]])

export default __exports__